<template>
  <SysDataTableExpand
    ref="sys_data_table_produtos_ref"
    v-model="produtos_selecionados"
    :height="ALTURA_GRID"
    :item-height="altura_linha_grid"
    :headers="CABECALHOS_COMPUTED"
    show-select
    :show-column-custom="ativar_personalizacao_colunas_sys_data_table"
    id-unique-preference="PERSONALIZACAO_COLUNAS_LISTA_PRODUTOS_TELA_PRODUTOS_COMPRAR"
    :search="ocultar_produtos_carrinho ? 'ocultar_produtos_carrinho' : null"
    :callback-filter-search="callbackFilterSearch"
    :item-class="classesCssLinha"
    ativar_ordenacao_manual
    :hide-border-bottom-tr="false"
    content-class="sys-data-table-gray-hover-linha cursor-pointer"
    :callbacks="CALLBACKS_DATA_TABLE"
    @click:row="clickLinhaGridProdutos"
    @scroll-items="rolagemDoGridProdutos"
    @callback-resetar-grid="fn => callbackResetarDadosGrid = fn"
    @click:th="() => abrir_dialog_ordenacao_count++"
  >
    <template #top>
      <TopoGrid
        :abrir_dialog_ordenacao_count="abrir_dialog_ordenacao_count"
        @campos:ordenacao="ev => campos_em_ordenacao = ev"
      >
        <template #input-pesquisa v-if="produtos_selecionados.length > 0 && !FILTROS.compra_categorias_ativa">
          <div class="d-flex align-center">
            <v-badge color="white" overlap>
              <v-btn small color="#042333" dark @click="adicionarProdutosNoCarrinho(produtos_selecionados)">
                <v-icon size="18" class="mr-1">mdi-cart</v-icon>
                adicionar
                <OpcoesParaAdicionarNoCarrinho
                  :produtos="produtos_selecionados"
                  @adicionar="ev => adicionarProdutosNoCarrinho(ev)"
                />
              </v-btn>

              <template #badge>
                <span class="text-black font-11" v-text="produtos_selecionados.length" />
              </template>
            </v-badge>

            <ConsolidarCompraParaUmaFilial
              v-if="FILTROS.filiais.length === 0 && COMPRA_DISTRIBUIDA_POR_FILIAL"
              :produtos_selecionados="produtos_selecionados"
              classes_css="ml-5"
              @consolidacao:filial-selecionada="ev => adicionarProdutosNoCarrinho(produtos_selecionados, ev.filial)"
            />

            <SilenciarProdutosDialog class="ml-4" :produtos="produtos_selecionados" @update:produtos-silenciados="removerProdutosSilenciados(produtos_selecionados)">
              <template #botao-ativador="{ callbackAbrirDialog }">
                <v-badge color="white" overlap>
                  <v-btn small color="red" dark @click="callbackAbrirDialog">
                    <v-icon size="15" class="mr-1">mdi-bell-off</v-icon>
                    silenciar
                  </v-btn>

                  <template #badge>
                    <span class="text-black font-11" v-text="produtos_selecionados.length" />
                  </template>
                </v-badge>
              </template>
            </SilenciarProdutosDialog>
          </div>
        </template>
      </TopoGrid>
    </template>

    <template v-for="(item, key) in campos_em_ordenacao" #[`header.${item.campo}.icon_order`]>
      <span :key="key">
        <v-icon v-if="item.ordem === 'DECRESCENTE'" small v-text="'mdi-arrow-down'" />
        <v-icon v-else small v-text="'mdi-arrow-up'" />
      </span>
    </template>

    <template #header.data-table-select v-if="FILTROS.compra_categorias_ativa">
      <span>&nbsp;</span>
    </template>

    <template #item.data-table-select-td="{isSelecded, select, item}">
      <template v-if="!FILTROS.compra_categorias_ativa">
        <v-icon v-if="item.produto_esta_combinado" color="#CECECE">mdi-checkbox-blank-outline</v-icon>

        <div v-else class="cursor-pointer" @click.stop="select">
          <v-icon v-if="isSelecded" :size="24" color="primary">mdi-checkbox-marked</v-icon>
          <v-icon v-else :size="24">mdi-checkbox-blank-outline</v-icon>
        </div>
      </template>
    </template>

    <template #header.classificacao_criticidade.text="{header}">
      <HeaderCurvaAbc :header="header">
        <LegendaCurvaAbcFaturamento bottom>{{ header.text }}</LegendaCurvaAbcFaturamento>
      </HeaderCurvaAbc>
    </template>

    <template #header.classificacao_rentabilidade.text="{header}">
      <HeaderCurvaAbc :header="header">
        <LegendaCurvaAbcRentabilidade bottom :texto="header.text" />
      </HeaderCurvaAbc>
    </template>

    <template #item.classificacao_criticidade="{value}">
      <LegendaCurvaAbcFaturamento :texto="value" />
    </template>

    <template #item.classificacao_rentabilidade="{value}">
      <LegendaCurvaAbcRentabilidade :texto="value" />
    </template>

    <template #item.sigla_grupo="{ item }">
      <div class="d-flex align-center">
        <div v-text="item.sigla_grupo" class="text-no-wrap" />

        <SilenciarProdutosDialog
          :produtos="[item]"
          @update:produtos-silenciados="removerProdutosSilenciados([item])"
        >
          <template #botao-ativador="{ callbackAbrirDialog }">
            <v-btn
              icon
              small
              :color="niveis_servicos[item.nivel_servico_chave].cor"
              :title="niveis_servicos[item.nivel_servico_chave].detalhes"
              @click.stop="!item.produto_eh_categoria && callbackAbrirDialog()"
            >
              <v-icon size="15">mdi-bell-off</v-icon>
            </v-btn>
          </template>
        </SilenciarProdutosDialog>

        <div v-if="!item.produto_eh_categoria" class="cursor-help">
          <v-icon v-if="item.produto_eh_combinacao" :size="17" title="Produto é uma combinação">mdi-vector-combine</v-icon>

          <v-icon v-if="item.em_completar_compra" size="17" title="Produto em completar compra">mdi-beer</v-icon>

          <v-icon v-if="item.projecao_vendas_personalizada" size="17">$ProjecaoVendasPersonalizada</v-icon>

          <v-icon
            v-if="item.produto_em_analise_por_lote"
            :size="16"
            :title="item.tipo === 'LT' ? 'Produto com sugestão de compra pela análise por lotes' : 'Produto em análise por lotes'"
            :color="item.tipo === 'LT' ? 'primary' : 'default'"
          >
            mdi-hexagon-multiple
          </v-icon>

          <v-icon
            small
            v-if="parseFloat(item.fator_atuacao) !== 1"
            :color="item.fator_atuacao > 1 ? 'green' : 'red'"
            v-text="item.fator_atuacao > 1 ? 'mdi-elevation-rise' : 'mdi-elevation-decline'"
            title="Produto com percentual de influência na projeção de vendas"
            class="mr-1"
          />

          <v-icon v-if="item.estoque_transito > 0" size="16" title="Produto em Trânsito">mdi-truck</v-icon>
          <v-icon v-else-if="item.tipo === 'FC'" size="16" title="Produto em Forecast">mdi-clock</v-icon>

          <v-icon v-if="item.tipo === 'CD'" size="16" title="Produto com sugestão pelo CD">$HomeBattery</v-icon>

          <v-icon v-if="item.tipo === 'TQ'" size="16" title="Produto em Completar compra por não fechar um lote de sugestão">mdi-gauge</v-icon>
          <v-icon v-else-if="item.tipo === 'EE'" size="16" title="Produto em Completar compra por causa do saldo de estoque está abaixo do estoque estético">mdi-cube-scan</v-icon>

          <v-icon v-if="item.baixa_movimentacao" :size="20" title="Produto de Baixa Movimentação" class="cursor-help">mdi-trending-down</v-icon>
        </div>
      </div>
    </template>

    <template #item.razao_social="{ value }">
      <div v-text="value" class="w-max-200 text-truncate" :title="value" />
    </template>

    <template #item.cod_produto="{ value }">
      <div v-text="value" class="text-no-wrap" />
    </template>

    <template #item.preco_compra="{ item }">
      <FormatarMoeda :tipo="item.moeda" />
      {{ Helpers.formatarValorComCasas(item.preco_compra, 2) }}
    </template>

    <template #item.compra_em_palete="{ item }">
      <CompraEmPalete
        :lastro_palete="Number(item.lastro_palete)"
        :altura_palete="Number(item.altura_palete)"
        :quantidade_compra="Number(item.sugestao)"
        :unidade_compra="EMBALAGEM_MASTER_ATIVA ? item.unidade_master : item.unidade_compra"
      />
    </template>

    <template #item.descricao_produto="{ item }">
      <div class="d-flex align-center">
        <ComparacaoProdutos
          v-if="item.produto_eh_combinacao && !item.produto_eh_categoria"
          :id_grupo="item.id_grupo"
          :filial="item.filial"
          :id_produto_combinado="String(item.idproduto)"
          :produtos="item.produtos"
          icon="mdi-information-outline"
          :size_icon="15"
          content_button_activator="ml-n3 mr-n2"
        />

        <span v-text="item.descricao_produto" class="text-no-wrap" />
      </div>
    </template>

    <template #item.unidade_compra="{ item }">
      {{ EMBALAGEM_MASTER_ATIVA ? item.unidade_master : item.unidade_compra }}
    </template>

    <template #item.estoque="{ value }">
      {{ formatarNumero(value) }}
    </template>

    <template #item.estoque_transito="{ value }">
      {{ formatarNumero(value) }}
    </template>

    <template #item.tempo_gatilho="{ value }">
      <span v-if="value > 0" v-text="`+ ${value}`" class="text-green" />
      <span v-else-if="value < 0" v-text="`- ${Math.abs(value)}`" class="text-red" />
      <span v-else-if="value === 0">Hoje</span>
      <span v-else>-</span>
    </template>

    <template #item.cobertura_est_futura="{ item }">
      <CalculaCoberturaEstoqueFutura :item="item" />
    </template>

    <template #item.consumo_medio_mensal="{ value }">
      {{ formatarNumero(value) }}
    </template>

    <template #item.sugestao="{ item }">
      <SugestaoDeCompra
        @forcar-atualizacao-input="e => item.sugestao = e"
        :ref="getRefComponenteSugestaoCompra(item)"
        :produto="{...item, sugestao_unidade_padrao: getQtdePedidoConvertida(item)}"
        @add-produto-carrinho="produto => adicionarProdutosNoCarrinho([{...item, sugestao: produto.sugestao}])"
        @add-produtos-categoria-no-carrinho="adicionarProdutosCategoriaNoCarrinho(item)"
        @dialog-multifilial-fechado="ev => dialogMultifilialFechado(ev, item)"
        @keydown.up="() => rolagemGridPelasSetas(item, true)"
        @keydown.down="() => rolagemGridPelasSetas(item, false)"
        @keyup.left="PRODUTO_SELECIONADO = {}"
        @keyup.right="PRODUTO_SELECIONADO = item"
        @fazer-novo-pedido-compra="() => item.compra_produto_nao_confirmada_no_erp = false"
      />
    </template>

    <template #footer="{countItems}">
      <RodapeGrid v-model="ocultar_produtos_carrinho" :qtdItens="countItems" />
    </template>
  </SysDataTableExpand>
</template>

<script>
import {cabecalhos} from "@/components/compra/ProdutosGerais/ListaProdutos/Cabecalhos";
import {niveis_servicos} from "@/components/compra/ProdutosGerais/ListaProdutos/NiveisDeServicos";
import ResponsiveHeight from "@/helpers/ResponsiveHeight";
import {buscarProdutosFiltros} from "@/api/compraPorProdutosGerais/Produtos";
import {formatarValor, iniciarRequisicao, logout} from "@/helpers";
import CarrinhoAPI from "@/api/carrinho.js";
import {info_pedido_geral} from "@/components/compra/ProdutosGerais/InfoPedidoGeral";
import {componentes} from "@/components/compra/ProdutosGerais/ListaProdutos/Componentes";
import {mapGetters} from "vuex";
import {converterEmbalagemItens} from "@/components/compra/ProdutosGerais/ConversorEmbalagem";
import api from "@/api/api";

const campos_conversao_embalagem = ['estoque', 'sugestao', 'lote_minimo', 'estoque_transito', 'estoque_pendente', 'sugestao_fixa_convertivel', 'estoque_futuro_tempo_ressuprimento', 'lastro_palete'];

export default {
  name: "Grid",
  components: componentes,
  mixins: [ResponsiveHeight],
  data: () => ({
    niveis_servicos,
    altura_linha_grid: 47,
    index_linha_produto_selecionado: null,
    produtos_selecionados: [],
    produtos_por_pagina: 300,
    timer_scroll_data_table: null,
    carregando_produtos: false,
    todos_produtos_carregados: false,
    ocultar_produtos_carrinho: localStorage.flag_multifiliais_ocultar_produto_carrinho === 'S',
    callbackResetarDadosGrid: null,
    campos_em_ordenacao: [],
    abrir_dialog_ordenacao_count: 0,
    ativar_personalizacao_colunas_sys_data_table: localStorage.ativar_personalizacao_colunas_sys_data_table === 'S',
  }),
  computed: {
    ...mapGetters({
      CALLBACK_ATUALIZAR_CARRINHO: "CompraProdutosGerais/callbackRecarregarPedidosCompraCarrinho",
      COMPRA_MULTI_FILIAL_ATIVA: "CompraDistribuidaPorFilial/get_distribuir_por_filial",
      CONSIDERAR_ESTOQUE_GRUPO_COMPRA_MULTI_FILIAL: "CompraDistribuidaPorFilial/get_considerar_estoque_grupo",
      FILTROS: "CompraProdutosGerais/getFiltros",
      VISAO_VERTICAL_ATIVA: "CompraProdutosGerais/getVisaoVertical",
      EMBALAGEM_MASTER_ATIVA: "EmbalagemTelaDeCompras/getEmbalagemMaster",
      COMPRA_DISTRIBUIDA_POR_FILIAL: "CompraDistribuidaPorFilial/get_distribuir_por_filial",
    }),
    ALTURA_GRID() {
      return this.VISAO_VERTICAL_ATIVA ? (this.alturaDaJanela - 158) : (this.alturaDaJanela - 498);
    },
    PRODUTO_SELECIONADO: {
      get: function () {
        return this.$store.getters['CompraProdutosGerais/getProdutoSelecionado'];
      },
      set: function (valor) {
        this.index_linha_produto_selecionado = valor.index_linha;
        return this.$store.dispatch('CompraProdutosGerais/setProdutoSelecionado', valor);
      }
    },
    PAGINA_ATUAL_PRODUTOS() {
      return Math.ceil(this.$refs.sys_data_table_produtos_ref.linhas.length / this.produtos_por_pagina);
    },
    CABECALHOS_COMPUTED() {
      let cabecalhos_tmp = cabecalhos;

      if (this.FILTROS.compra_produtos_combinados_ativa) {
        cabecalhos_tmp = cabecalhos_tmp.filter(cabecalho => !['razao_social'].includes(cabecalho.value))
      }

      if (localStorage.ativar_exibicao_campo_numero_original !== 'S') {
        cabecalhos_tmp = cabecalhos_tmp.filter(item => item.value !== 'numero_original');
      }

      return cabecalhos_tmp;
    },
    CALLBACKS_DATA_TABLE() {
      if (!this.FILTROS.compra_categorias_ativa) {
        return [async () => []];
      }

      return [this.buscarListaCategorias, this.buscarListaProdutos];
    }
  },
  watch: {
    FILTROS: {
      handler() {
        this.todos_produtos_carregados = false;
        this.resetarDadosTabelaProdutos();
      },
      deep: true
    },
    ocultar_produtos_carrinho() {
      if (this.$refs.sys_data_table_produtos_ref.linhas.length < 100 && !this.FILTROS.compra_categorias_ativa) {
        this.atualizarListaProdutos();
      }
    },
    EMBALAGEM_MASTER_ATIVA() {
      this.$refs.sys_data_table_produtos_ref.linhas = converterEmbalagemItens(this.$refs.sys_data_table_produtos_ref.linhas, campos_conversao_embalagem);
    }
  },
  mounted() {
    if (!this.FILTROS.compra_categorias_ativa) {
      setTimeout(() => this.atualizarListaProdutos(), 500);
    }

    this.$store.dispatch("CompraProdutosGerais/callbackRecarregarTabelaProdutos", this.resetarDadosTabelaProdutos);
  },
  destroyed() {
    this.$store.dispatch("tabela_compra/resetColunasEmOrdenacaoCombinada");
  },
  methods: {
    formatarNumero: formatarValor,
    resetarDadosTabelaProdutos() {
      this.$refs.sys_data_table_produtos_ref.linhas = [];
      this.produtos_selecionados = [];
      this.todos_produtos_carregados = false;
      this.carregando_produtos = false;
      this.atualizarListaProdutos();
    },
    atualizarListaProdutos() {
      if (this.FILTROS.compra_categorias_ativa) {
        this.callbackResetarDadosGrid();
      } else {
        this.atualizarListaProdutosNoDataTable();
      }
    },
    atualizarListaProdutosNoDataTable() {
      this.buscarListaProdutos()
        .then(produtos => {
          this.$refs.sys_data_table_produtos_ref.linhas.push(...produtos);
          this.carregando_produtos = false;
          this.todos_produtos_carregados = produtos.length !== this.produtos_por_pagina;
        })
    },
    async buscarListaProdutos(linha = {}) {
      if (!this.FILTROS.compra_categorias_ativa && (this.todos_produtos_carregados || this.carregando_produtos)) {
        return;
      }

      this.carregando_produtos = true;

      const parametros = {
        pagina: linha.produto_eh_categoria ? 1 : (this.PAGINA_ATUAL_PRODUTOS + 1),
        produtos_por_pagina: linha.produto_eh_categoria ? 10000000 : this.produtos_por_pagina,
        filtros: {
          ...this.FILTROS,
          grupos: linha.produto_eh_categoria ? [linha.id_grupo] : this.FILTROS.grupos,
          filiais: linha.filial ? [linha.filial] : this.FILTROS.filiais,
          categorias: linha.produto_eh_categoria ? [linha.idproduto] : this.FILTROS.categorias,
        },
        compra_por_filial: this.COMPRA_MULTI_FILIAL_ATIVA ? 'S' : 'N',
        considerar_estoque_grupo: this.CONSIDERAR_ESTOQUE_GRUPO_COMPRA_MULTI_FILIAL ? 'S' : 'N',
      }

      return buscarProdutosFiltros(parametros)
        .then(produtos => {
          const callback = item => {
            item.sugestao_fixa_convertivel = Number(item.sugestao);
            item.sugestao = Number(item.sugestao);
            item.tempo_gatilho = parseInt(item.tempo_gatilho);
            item.nivel_servico_chave = `${item.nivel_servico || ''}`.toLowerCase()
              .replace('nivel', '')
              .trim()
              .replaceAll(' ', '_');
            return item;
          };

          if (this.EMBALAGEM_MASTER_ATIVA) {
            produtos = converterEmbalagemItens(produtos, campos_conversao_embalagem);
          }

          return produtos.map(callback);
        })
        .catch(logout)
    },
    async buscarListaCategorias() {
      const parametros = {
        pagina: (this.PAGINA_ATUAL_PRODUTOS + 1),
        produtos_por_pagina: this.produtos_por_pagina,
        filtros: this.FILTROS,
        compra_por_filial: this.COMPRA_MULTI_FILIAL_ATIVA ? 'S' : 'N',
        considerar_estoque_grupo: this.CONSIDERAR_ESTOQUE_GRUPO_COMPRA_MULTI_FILIAL ? 'S' : 'N',
      };

      return api.post('compras/produtos/categorias', parametros)
        .then(response => {
          const callback = item => {
            item.sugestao = Number(item.sugestao);
            item.tempo_gatilho = parseInt(item.tempo_gatilho);
            item.nivel_servico_chave = `${item.nivel_servico || ''}`.toLowerCase()
              .replace('nivel', '')
              .trim()
              .replaceAll(' ', '_');
            return item;
          };

          return response.data.categorias.map(callback);
        })
        .catch(logout)
    },
    clickLinhaGridProdutos({row}) {
      this.PRODUTO_SELECIONADO = row;
      this.focarNoInputSugestaoCompraPorIndexLinhaSelecionado();
    },
    verificaSeMultiploDeLoteMinimo(item) {
      if (!item.lote_minimo) return false;

      const sugestao = parseFloat(item.sugestao).toFixed(4);
      const loteMinimo = parseFloat(item.lote_minimo).toFixed(4);
      const modulo = (sugestao % loteMinimo).toFixed(4);

      return (modulo == 0 || modulo == loteMinimo);
    },
    getQtdePedidoConvertida(produto) {
      if (!this.EMBALAGEM_MASTER_ATIVA) {
        return parseFloat(produto.sugestao);
      }

      if (produto.tipo_fator_conversao === 'D') {
        return parseFloat(produto.sugestao * produto.multiplo_compra);
      }

      return parseFloat(produto.sugestao / produto.multiplo_compra);
    },
    adicionarProdutosNoCarrinho(produtos, filial_consolidacao_sugestao = null) {
      const produtos_formatados = [];

      produtos.forEach(produto => {
        if (!this.verificaSeMultiploDeLoteMinimo || !(produto.sugestao > 0) || produto.produto_esta_combinado) {
          return;
        }

        if (produto.compra_produto_nao_confirmada_no_erp) {
          return;
        }

        produtos_formatados.push({
          grupo: produto.id_grupo,
          filial: (produto.filial > 0) ? produto.filial : 0,
          fornecedor: (this.FILTROS.fornecedores.length > 0) ? produto.idfornecedor : info_pedido_geral.idfornecedor,
          produto: produto.idproduto,
          qtde: this.getQtdePedidoConvertida(produto),
          sugestao: produto.sugestao_fixa,
          tipo_compra: produto.tipo,
          usuario: localStorage.id,
          analiseGrupoFornecedores: (this.FILTROS.fornecedores.length > 0 || this.FILTROS.compra_produtos_combinados_ativa) ? 'N' : 'S',
          idsegmento: (this.FILTROS.segmentos.length > 0) ? produto.idsegmento : 0,
          idsecao: (this.FILTROS.secoes.length > 0) ? produto.idsecao : 0,
          considerar_estoque_grupo: this.CONSIDERAR_ESTOQUE_GRUPO_COMPRA_MULTI_FILIAL ? 'S' : 'N',
          produto_eh_combinacao: produto.produto_eh_combinacao || false,
          forcar_aplicacao_filtro_comprador: this.$route.path === '/compras/produtos',
          emb_master: this.EMBALAGEM_MASTER_ATIVA ? 'S' : 'N',
        });
      });

      if (produtos_formatados.length === 0) {
        this.produtos_selecionados = [];
        alert('Nenhum produto válido para ser adicionado ao carrinho de compras.');
        return;
      }

      if (this.COMPRA_MULTI_FILIAL_ATIVA) {
        this.adicionarProdutosNoCarrinhoCompraPorMultifilial(produtos_formatados, filial_consolidacao_sugestao);
      } else {
        this.adicionarProdutosNoCarrinhoCompraPorGrupo(produtos_formatados);
      }
    },
    adicionarProdutosNoCarrinhoCompraPorGrupo(produtos) {
      CarrinhoAPI.addMultCarrinhoGrupo(iniciarRequisicao(), produtos)
        .then(response => {
          localStorage.token = response.data.token;
          this.produtos_selecionados = [];
          this.removerProdutosAdicionadosNoCarrinho(produtos);
          this.CALLBACK_ATUALIZAR_CARRINHO();
        })
        .catch(logout);
    },
    adicionarProdutosNoCarrinhoCompraPorMultifilial(produtos, filial_consolidacao_sugestao = null) {
      api.post("compras/produtos/carrinho/produtos/multifiliais", {produtos, filial_consolidacao_sugestao})
        .then(() => {
          this.produtos_selecionados = [];
          this.removerProdutosAdicionadosNoCarrinho(produtos);
          this.CALLBACK_ATUALIZAR_CARRINHO();
        })
        .catch(logout);
    },
    async adicionarProdutosCategoriaNoCarrinho(linha) {
      const produtos = await this.buscarListaProdutos(linha)
      const produtos_com_sugestao_compra = produtos.filter(produto => Number(produto.qtd_pedidos_com_produto) === 0 && Number(produto.sugestao) > 0);
      this.adicionarProdutosNoCarrinho(produtos_com_sugestao_compra);

      const produtos_para_remocao = [linha, ...produtos].map(item => ({grupo: item.id_grupo, filial: item.filial || 0, produto: item.idproduto}));
      this.removerProdutosAdicionadosNoCarrinho(produtos_para_remocao);
    },
    removerProdutosAdicionadosNoCarrinho(produtos_adicionados) {
      produtos_adicionados.forEach(produto => {
        const callback = item => `${item.id_grupo}-${item.filial || 0}-${item.idproduto}` === `${produto.grupo}-${produto.filial}-${produto.produto}`;
        const index_remocao = this.$refs.sys_data_table_produtos_ref.linhas.findIndex(callback);

        if (index_remocao !== -1) {
          this.$refs.sys_data_table_produtos_ref.linhas = this.$refs.sys_data_table_produtos_ref.linhas.filter((_, index) => index !== index_remocao);
        }
      });
    },
    rolagemDoGridProdutos(ev) {
      this.verificarFinalRolagem(ev);
      this.$nextTick(this.focarNoInputSugestaoCompraPorIndexLinhaSelecionado);
    },
    verificarFinalRolagem({scrollHeight, scrollTop, offsetHeight}) {
      if ((scrollTop + offsetHeight + 150) < scrollHeight || this.carregando_produtos) {
        return;
      }

      clearTimeout(this.timer_scroll_data_table);
      this.timer_scroll_data_table = setTimeout(this.atualizarListaProdutos, 500)
    },
    classesCssLinha(linha) {
      return {
        'sys-data-table-gray-linha': linha.index_linha === this.index_linha_produto_selecionado,
        'text-gray-100': linha.qtd_pedidos_com_produto > 0 || linha.produto_esta_combinado || linha.compra_produto_nao_confirmada_no_erp,
        'text-orange': linha.revenda == 'N',
        'text-red': linha.status == 'FL',
      };
    },
    dialogMultifilialFechado(ev, produto) {
      produto.qtd_pedidos_com_produto = ev.qtd_pedidos_filial_com_produto;
      this.CALLBACK_ATUALIZAR_CARRINHO();
    },
    removerProdutosSilenciados(produtos_silenciados) {
      const callback = item => !produtos_silenciados.some(sub_item => sub_item.index_linha === item.index_linha);
      this.$refs.sys_data_table_produtos_ref.linhas = this.$refs.sys_data_table_produtos_ref.linhas.filter(callback);
      this.produtos_selecionados = [];
      this.$store.getters['CompraProdutosGerais/callbackRecarregarQtdeProdutosSilenciados']();
    },
    getRefComponenteSugestaoCompra({index_linha}) {
      return `sugestao-compra-${index_linha}-ref`;
    },
    focarNoInputSugestaoCompraPorIndexLinhaSelecionado() {
      const chave_ref = this.getRefComponenteSugestaoCompra({index_linha: this.index_linha_produto_selecionado});
      const element = this.$refs[chave_ref];

      if (!this.index_linha_produto_selecionado || !element) return;

      setTimeout(() => element.focus(), 150)
    },
    rolagemGridPelasSetas(produto, rolar_para_cima) {
      const index = this.$refs.sys_data_table_produtos_ref.linhas.findIndex(item => item.index_linha === produto.index_linha);
      const index_proximo_produto = index + (rolar_para_cima ? -1 : 1);

      if (index_proximo_produto < 0 || index_proximo_produto > (this.$refs.sys_data_table_produtos_ref.linhas.length - 1)) {
        return;
      }

      const element = this.$refs.sys_data_table_produtos_ref.$el.querySelector('#sys-data-table-body');
      element.scrollTop = ((index_proximo_produto + 1) * this.altura_linha_grid) - (this.ALTURA_GRID / 2);
      this.index_linha_produto_selecionado = this.$refs.sys_data_table_produtos_ref.linhas[index_proximo_produto].index_linha;
      this.focarNoInputSugestaoCompraPorIndexLinhaSelecionado();
    },
    // ordenarColunaSelecionadaPeloGrid(rules) {
    //   this.$store.dispatch("tabela_compra/resetColunasEmOrdenacaoCombinada");
    //   this.ordenarColunaSelecionada(rules);
    // },
    // ordenarColunaSelecionada(rules) {
    //   const ev = {
    //     rules,
    //     itens_personalizadas: this.$refs.sys_data_table_produtos_ref.linhas
    //   };
    //   this.$store.commit("tabela_compra/ordenarItensArray", ev);
    // },
    callbackFilterSearch(item) {
      return item.produto_eh_categoria || !item.qtd_pedidos_com_produto;
    },
    teste() {}
  }
}
</script>
